export enum ContentModelVersion { // TBD: remove when ContentApi updates contracts in scope of US 986553
  V2 = 'v2',
}
